import React from 'react';

const AboutDialog = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/30">
      <div
        className="bg-[#F0F0F0] border border-[#808080] shadow-2xl"
        style={{ width: 420, fontFamily: 'Tahoma, Segoe UI, sans-serif' }}
      >
        <div className="flex items-center justify-between h-[26px] bg-[#2B579A] text-white px-[8px]">
          <span className="text-[12px]">About Active Directory Users and Computers</span>
          <button
            onClick={onClose}
            className="w-[28px] h-[26px] hover:bg-[#E81123] flex items-center justify-center"
          >
            <svg width="10" height="10" viewBox="0 0 10 10">
              <line x1="1" y1="1" x2="9" y2="9" stroke="#FFF" strokeWidth="1.2" />
              <line x1="9" y1="1" x2="1" y2="9" stroke="#FFF" strokeWidth="1.2" />
            </svg>
          </button>
        </div>
        <div className="flex p-[16px]">
          <div className="mr-[14px]">
            <svg width="52" height="52" viewBox="0 0 16 16">
              <circle cx="8" cy="8" r="7" fill="#E3F0FF" stroke="#4A7AB8" strokeWidth="0.5" />
              <rect x="5" y="2" width="6" height="4" fill="#B8D4F0" stroke="#2B579A" strokeWidth="0.5" />
              <rect x="1" y="10" width="5" height="3" fill="#B8D4F0" stroke="#2B579A" strokeWidth="0.5" />
              <rect x="10" y="10" width="5" height="3" fill="#B8D4F0" stroke="#2B579A" strokeWidth="0.5" />
              <line x1="8" y1="6" x2="3" y2="10" stroke="#2B579A" strokeWidth="0.4" />
              <line x1="8" y1="6" x2="13" y2="10" stroke="#2B579A" strokeWidth="0.4" />
            </svg>
          </div>
          <div className="text-[12px] text-black">
            <div className="font-bold mb-[6px]">Active Directory Users and Computers</div>
            <div className="mb-[2px]">Version 10.0.17763 (Windows Server 2016 style)</div>
            <div className="mb-[10px]">Portfolio edition &middot; yourname.local</div>
            <div className="text-[11px] text-[#444] leading-[1.45]">
              This console is a faithful recreation of the Microsoft Management Console (MMC)
              snap-in for Active Directory Users and Computers. It doubles as a professional
              IT &amp; Cybersecurity resume. Navigate Organizational Units to browse my
              experience, certifications, skills, projects, and education.
            </div>
            <div className="mt-[10px] text-[11px] text-[#666]">
              Built with React, Tailwind CSS, and love for blue-team operations.
            </div>
          </div>
        </div>
        <div className="flex justify-end bg-[#F0F0F0] px-[12px] py-[10px] border-t border-[#D0D0D0]">
          <button
            onClick={onClose}
            className="min-w-[80px] h-[23px] text-[12px] border border-[#707070] bg-[#F0F0F0] hover:border-[#2B579A] hover:bg-[#DCE9F9] active:bg-[#B0CEEC]"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutDialog;
